import { render } from "./ListSakitView.vue?vue&type=template&id=1a0ba565"
import script from "./ListSakitView.vue?vue&type=script&lang=js"
export * from "./ListSakitView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__